/**
 * Verbindliche IDs aus dem Datenmodell (Version 1.0.0).
 * Als enge Union-Typen abgebildet, damit Rechenlogik und UI exhaustive Checks nutzen können (TS-003/TS-004).
 */

export const QUESTION_IDS = [
  'audience_activity',
  'feed_relevance',
  'visual_explainability',
  'transformation_visibility',
  'topic_depth',
  'trust_relevance',
  'communication_preference',
  'public_response_tolerance',
  'personal_visibility',
  'content_system',
  'offer_proof',
  'sales_path',
  'business_tracking',
  'instagram_independence',
] as const;
export type QuestionId = (typeof QUESTION_IDS)[number];

export const CLUSTER_IDS = [
  'audience_demand',
  'topic_content',
  'trust_visibility',
  'daily_execution',
  'sales_readiness',
  'instagram_independence',
] as const;
export type ClusterId = (typeof CLUSTER_IDS)[number];

export const CONTEXT_FIELD_IDS = [
  'productType',
  'priceRange',
  'audienceType',
  'offerStage',
  'instagramExperience',
  'desiredInstagramRole',
  'visibilityModel',
  'weeklyTimeBudget',
  'personalSalesEffort',
] as const;
export type ContextFieldId = (typeof CONTEXT_FIELD_IDS)[number];

export const OVERALL_BAND_IDS = [
  'wrong_primary_channel',
  'supporting_channel',
  'suitable_with_conditions',
  'strong_potential_fit',
] as const;
export type OverallBandId = (typeof OVERALL_BAND_IDS)[number];

export const CLUSTER_LEVEL_IDS = ['very_low', 'low', 'medium', 'high', 'very_high'] as const;
export type ClusterLevelId = (typeof CLUSTER_LEVEL_IDS)[number];

export const SEVERITY_IDS = ['notice', 'important', 'critical'] as const;
export type SeverityId = (typeof SEVERITY_IDS)[number];

export const CHANNEL_ROLE_IDS = [
  'primary_channel',
  'supporting_channel',
  'trust_channel',
  'advertising_channel',
  'test_later',
  'currently_not_recommended',
] as const;
export type ChannelRoleId = (typeof CHANNEL_ROLE_IDS)[number];

export const VISIBILITY_MODEL_IDS = [
  'personal_expert',
  'professional_personal_brand',
  'method_or_product_brand',
  'faceless',
] as const;
export type VisibilityModelId = (typeof VISIBILITY_MODEL_IDS)[number];

export const RECOMMENDATION_GROUPS = ['first', 'next', 'later'] as const;
export type RecommendationGroup = (typeof RECOMMENDATION_GROUPS)[number];

export const SESSION_STEPS = [
  'welcome',
  'preparation',
  'context',
  'questions',
  'review',
  'result',
] as const;
export type SessionStep = (typeof SESSION_STEPS)[number];

export const CONFIDENCE_IDS = ['low', 'medium', 'high'] as const;
export type ConfidenceId = (typeof CONFIDENCE_IDS)[number];

/** Exhaustiveness helper for switch statements over closed unions (TS-003). */
export function assertNever(value: never, context = 'Unbekannter Wert'): never {
  throw new Error(`${context}: ${JSON.stringify(value)}`);
}
